import SubscriptionPlanDTO from "@tootsweet/model/datatransfer/SubscriptionPlanDTO";

export function sortByPriceAndNoPriceFlag(array: SubscriptionPlanDTO[]) {
  return [...array].sort((a, b) => {
    if (a.noPrice === true && b.noPrice !== true) return 1;
    if (a.noPrice !== true && b.noPrice === true) return -1;
    return (a.price || 0) - (b.price || 0);
  });
}
